import { EventrDate, setUserPref } from "@eventr/common";
import { ColoursObj, getFlagEmojiFromTimezoneEnum, Typography } from "@eventr/common-storybook";
import { Box } from "@mui/material";
import i18n from "i18n/i18next";
import { bs } from "state/bound.store";
import { defaultAddSnack } from "state/overlayState/overlayContext";
import { useUserPrefsStore } from "state/userPrefsState/userPrefs.store";
import HitBoxIcon from "./HitBoxIcon";

/** Switches the itinerary between its own time zones and the user's local one. */
export function toggleZoneMode() {
  if (useUserPrefsStore.getState().showDestTime === "userLocal") {
    setUserPref("itinerary", "showDestTime", "itinLocal");
    useUserPrefsStore.getState().setShowDestTime("itinLocal");
    bs().setCurrentItin(bs().selectedItinID);
    defaultAddSnack(i18n.t("snack.timezoneToggleEvent"), "info");
  } else {
    setUserPref("itinerary", "showDestTime", "userLocal");
    useUserPrefsStore.getState().setShowDestTime("userLocal");
    bs().setCurrentItin(bs().selectedItinID);
    defaultAddSnack(i18n.t("snack.timezoneToggleUser"), "info");
  }
}

/**
 * Toggle for zone of itin or user local zone
 */
export default function CarouselZoneToggle({ colour = ColoursObj.shades.shade5 }: { colour?: string }) {
  const localTzEventrDate = new EventrDate();

  const showDestTime = useUserPrefsStore((s) => s.showDestTime);

  const showInUsersTime = showDestTime === "userLocal";

  /// For now using a switch but might change to a 3way toggle or something if adding utc
  return (
    <Box
      sx={{
        display: "grid",
        gridAutoFlow: "column",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: "24px",
        }}
      >
        {showInUsersTime && getFlagEmojiFromTimezoneEnum(localTzEventrDate.timezoneNumber ?? 0)}
      </Typography>

      <HitBoxIcon id="carousel-timezone-toggle" onClick={toggleZoneMode} icon="Time" colour={colour} />
    </Box>
  );
}
